/**
 * Interceptor para adicionar headers de contexto nas requisições ao Supabase
 */

import { SupabaseClient } from '@supabase/supabase-js';

export interface ContextHeaders {
  'X-Network-Id'?: string;
  'X-Store-Id'?: string;
  'X-Acting-As-Store-Id'?: string;
  'X-Context-Mode'?: 'NETWORK' | 'STORE';
}

let currentContext: {
  networkId: string | null;
  storeId: string | null;
  actingAsStoreId: string | null;
  contextMode: 'NETWORK' | 'STORE';
} = {
  networkId: null,
  storeId: null,
  actingAsStoreId: null,
  contextMode: 'NETWORK',
};

/**
 * Atualiza o contexto global para o interceptor
 */
export const updateInterceptorContext = (context: {
  networkId: string | null;
  storeId: string | null;
  actingAsStoreId?: string | null;
  contextMode: 'NETWORK' | 'STORE';
}): void => {
  currentContext = {
    networkId: context.networkId,
    storeId: context.storeId,
    actingAsStoreId: context.actingAsStoreId || null,
    contextMode: context.contextMode,
  };
};

/**
 * Obtém os headers de contexto atuais
 */
export const getContextHeaders = (): ContextHeaders => {
  const headers: ContextHeaders = {
    'X-Context-Mode': currentContext.contextMode,
  };

  if (currentContext.networkId) {
    headers['X-Network-Id'] = currentContext.networkId;
  }

  if (currentContext.storeId) {
    headers['X-Store-Id'] = currentContext.storeId;
  }

  if (currentContext.actingAsStoreId) {
    headers['X-Acting-As-Store-Id'] = currentContext.actingAsStoreId;
  }

  return headers;
};

/**
 * Cria um cliente Supabase com headers de contexto
 */
export const createContextualSupabaseClient = (client: SupabaseClient): SupabaseClient => {
  // Por enquanto, retornamos o cliente original
  // Em uma implementação futura, podemos usar um proxy para adicionar headers
  // automaticamente em todas as chamadas
  return client;
};

/**
 * Adiciona headers de contexto a uma query do Supabase
 * Nota: Supabase não suporta headers customizados diretamente nas queries,
 * então essa função é para referência futura se implementarmos via Edge Functions
 */
export const addContextToQuery = <T>(
  query: any,
  networkId?: string,
  storeId?: string,
  actingAsStoreId?: string
): any => {
  // Esta é uma função placeholder para quando implementarmos
  // chamadas via Edge Functions que suportem headers customizados
  return query;
};
